import { Component, inject, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import * as AOS from 'aos';
import { WelcomeMessageComponent } from 'src/app/components/versions/welcome-message/welcome-message.component';
import { NewsContentService } from './services/news-content.service';
import { FilterDto } from 'src/app/shared/models/filter';
import { NotificationService } from './serviceNotifications/notification.service';




@Component({
  selector: 'app-home-banner',
  templateUrl: './home-banner.component.html',
  styleUrls: ['./home-banner.component.scss']
})
export class HomeBannerComponent implements OnInit {
     private modalService = inject(NgbModal);

@Input() homeData :any ;

 marqueeData :any = [] ;
 filter: FilterDto = new FilterDto()

constructor(
  private _NewsContentService:NewsContentService,
  private _NotificationService:NotificationService,

){

  this._NotificationService.watch().valueChanges.subscribe(
    (result :any)=>{
      this.marqueeData = result.data.queryNotificationBarContents;
      console.log("notMartina",this.marqueeData)
    }


)

}

isShow: boolean = sessionStorage.getItem("isOpend") == null ? true: false ;




  ngOnInit(): void {
    // AOS.init();

    if(this.isShow){
      this.showWelcome();
      sessionStorage.setItem("isOpend" , "true")
    }
  }

  showWelcome(){
    this.modalService.open(WelcomeMessageComponent)
  }
}
